//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "item",
  props: {
    txt: String,
    page: String,
    select: String,
    activeimg: String,
    img: String
  },
  computed: {
    isSelected: function () {
      if (this.select == this.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    routeChange() {
      this.$router.push(this.page);
      this.$emit('change', this.page);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/tabbar/item.vue